export const questionClientNames = [
	"kizi",
	// "risk",
	"overstappen",
	"dyme",
	"consumentenbond",
	// "swiftonline",
] as const;
export type QuestionClientName = typeof questionClientNames[number];
